"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("react");
var item_icon_1 = require("../components/item_icon");
var constants_1 = require("../constants");
var formatDay = function (value) { return (value ? (0, utils_1.formatDateTime)(new Date(value), "dd LLL yyyy") : "N/A"); };
function useRenderCellViews(rowActions) {
    var renderCellViews = (0, react_2.useCallback)(function (item) {
        var _a, _b;
        return [
            { key: "icon", content: (0, jsx_runtime_1.jsx)(item_icon_1.ItemIcon, { item: item }) },
            {
                key: "name",
                content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-nowrap text-sm font-medium text-default-foreground", children: item.name }), item.description ? (0, jsx_runtime_1.jsx)("span", { className: "max-w-[260px] truncate text-xs text-muted", children: item.description }) : null] })),
            },
            {
                key: "type",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: "accent", children: (0, constants_1.itemTypeLabel)(item.type) })),
            },
            {
                key: "issued_count",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: (0, constants_1.describeItemQuantity)(item.quantity_limited, item.quantity, (_a = item.issued_count) !== null && _a !== void 0 ? _a : 0) }),
            },
            { key: "held_count", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: ((_b = item.held_count) !== null && _b !== void 0 ? _b : 0).toLocaleString() }) },
            {
                key: "dates_enabled",
                content: item.dates_enabled ? ((0, jsx_runtime_1.jsxs)("div", { className: "text-nowrap text-sm text-default-foreground", children: [formatDay(item.start_date), " to ", formatDay(item.end_date)] })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-nowrap text-sm text-muted", children: "Always available" })),
            },
            {
                key: "updated_at",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: item.updated_at ? (0, utils_1.formatDateTime)(new Date(item.updated_at)) : "N/A" }),
            },
            {
                key: "row_actions",
                content: (0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-end gap-2", children: rowActions(item).map(function (_a) {
                        var element = _a.element;
                        return element;
                    }) }),
            },
        ];
    }, [rowActions]);
    return (0, react_2.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
